{
	"adjustmentByName": "{{adjustmentName}}",
	"applyAiStyle": "Apply AI Style",
	"applyColorMatch": "Apply Color Match",
	"applyPreset": "Apply Preset: {{presetName}}",
	"ariaHistoryPanel": "History Panel",
	"autoLightingWb": "Auto Lighting & WB",
	"cropCrop": "Crop",
	"cropFlip": "Flip",
	"cropReset": "Reset Crop",
	"cropRotate": "Rotate",
	"cropStraighten": "Straighten",
	"ctrlAddPointColor": "Added Point Color Swatch",
	"ctrlAiErase": "AI Erase",
	"ctrlAiGenerate": "AI Generate",
	"ctrlAutoStraighten": "Auto Straighten",
	"ctrlAquaHue": "Aqua Hue",
	"ctrlAquaLuminance": "Aqua Luminance",
	"ctrlAquaSaturation": "Aqua Saturation",
	"ctrlAsShotWB": "Set As-Shot White Balance",
	"ctrlAutoVertical": "Auto Vertical",
	"ctrlBlacks": "Blacks",
	"ctrlBlueHue": "Blue Hue",
	"ctrlBlueLuminance": "Blue Luminance",
	"ctrlBlueSaturation": "Blue Saturation",
	"ctrlCalibrationBlueHue": "Calibration Blue Hue",
	"ctrlCalibrationBlueSat": "Calibration Blue Saturation",
	"ctrlCalibrationGreenHue": "Calibration Green Hue",
	"ctrlCalibrationGreenSat": "Calibration Green Saturation",
	"ctrlCalibrationRedHue": "Calibration Red Hue",
	"ctrlCalibrationRedSat": "Calibration Red Saturation",
	"ctrlClarity": "Clarity",
	"ctrlColorNoiseReduction": "Color Noise Reduction",
	"ctrlEnableProfileCorrections": "Enable Profile Corrections",
	"ctrlContrast": "Contrast",
	"ctrlCorrectLensCA": "Correct Lens Chromatic Aberration",
	"ctrlCorrectLensDistortion": "Correct Lens Distortion",
	"ctrlCorrectLensVignette": "Correct Lens Vignette",
	"ctrlCrop": "Crop",
	"ctrlCropStraighten": "Crop Straighten",
	"ctrlCurves": "Curves",
	"ctrlCurvesBlue": "Curves: Blue Channel",
	"ctrlCurvesCustom": "Curves: Custom",
	"ctrlCurvesGreen": "Curves: Green Channel",
	"ctrlCurvesRed": "Curves: Red Channel",
	"ctrlCustomWB": "Set Custom White Balance",
	"ctrlDefringeGreen": "Defringe Green",
	"ctrlDefringeGreenAmount": "Defringe Green Amount",
	"ctrlDefringeGreenHueRange": "Defringe Green Hue Range",
	"ctrlDefringePurple": "Defringe Purple",
	"ctrlDefringePurpleAmount": "Defringe Purple Amount",
	"ctrlDefringePurpleHueRange": "Defringe Purple Hue Range",
	"ctrlDehaze": "Dehaze",
	"ctrlDensity": "Density",
	"ctrlDistortion": "Distortion",
	"ctrlEnableLensCorrections": "Enable Lens Corrections",
	"ctrlExposure": "Exposure",
	"ctrlFeather": "Feather",
	"ctrlFlipHorizontally": "Flip Horizontally",
	"ctrlFlipVertically": "Flip Vertically",
	"ctrlFlow": "Flow",
	"ctrlGradingBalance": "Color Grading Balance",
	"ctrlGradingBlending": "Color Grading Blending",
	"ctrlGrainAmount": "Grain Amount",
	"ctrlGrainRoughness": "Grain Roughness",
	"ctrlGrainSize": "Grain Size",
	"ctrlGlobalHue": "Global Hue",
	"ctrlGlobalLuminance": "Global Luminance",
	"ctrlGlobalSaturation": "Global Saturation",
	"ctrlGreenHue": "Green Hue",
	"ctrlGreenLuminance": "Green Luminance",
	"ctrlGreenSaturation": "Green Saturation",
	"ctrlHighlights": "Highlights",
	"ctrlHighlightsHue": "Highlights Hue",
	"ctrlHighlightsLuminance": "Highlights Luminance",
	"ctrlHighlightsSaturation": "Highlights Saturation",
	"ctrlHorizontalPerspective": "Horizontal Perspective",
	"ctrlHueRange": "Hue Range",
	"ctrlHueShift": "Hue Shift",
	"ctrlImportLut": "Import LUT",
	"ctrlLensDistortionFactor": "Lens Distortion Correction Factor",
	"ctrlLensVignetteFactor": "Lens Vignette Correction Factor",
	"ctrlLuminanceNoiseReduction": "Luminance Noise Reduction",
	"ctrlLuminanceRange": "Luminance Range",
	"ctrlLuminanceShift": "Luminance Shift",
	"ctrlLutStrength": "LUT Strength",
	"ctrlMagentaHue": "Magenta Hue",
	"ctrlMagentaLuminance": "Magenta Luminance",
	"ctrlMagentaSaturation": "Magenta Saturation",
	"ctrlMidtonesHue": "Midtones Hue",
	"ctrlMidtonesLuminance": "Midtones Luminance",
	"ctrlMidtonesSaturation": "Midtones Saturation",
	"ctrlOrangeHue": "Orange Hue",
	"ctrlOrangeLuminance": "Orange Luminance",
	"ctrlOrangeSaturation": "Orange Saturation",
	"ctrlPerspectiveAspect": "Perspective Aspect",
	"ctrlPerspectiveRotate": "Perspective Rotate",
	"ctrlPerspectiveScale": "Perspective Scale",
	"ctrlPointColorShifts": "Point Color Shifts",
	"ctrlRadius": "Radius",
	"ctrlRange": "Range",
	"ctrlRedHue": "Red Hue",
	"ctrlRedLuminance": "Red Luminance",
	"ctrlRedSaturation": "Red Saturation",
	"ctrlRemove": "Remove",
	"ctrlRemoveAllPointColors": "Removed All Point Color Swatches",
	"ctrlRemoveLut": "Remove LUT",
	"ctrlRemoveMask": "Remove Mask",
	"ctrlRemovePointColor": "Removed Point Color Swatch",
	"ctrlRenameMask": "Rename Mask",
	"ctrlRenameMaskGroup": "Rename Mask Group",
	"ctrlResetCrop": "Reset Crop",
	"ctrlResetGrading": "Reset Color Grading",
	"ctrlResetParametricCurve": "Reset Parametric Curve",
	"ctrlResetParametricDarks": "Reset Parametric Darks",
	"ctrlResetParametricHighlights": "Reset Parametric Highlights",
	"ctrlResetParametricLights": "Reset Parametric Lights",
	"ctrlResetParametricShadows": "Reset Parametric Shadows",
	"ctrlResetRemovals": "Reset Removals",
	"ctrlRetouching": "Retouching",
	"ctrlRotateCCW": "Rotate CCW",
	"ctrlRotateCW": "Rotate CW",
	"ctrlParametricDarks": "Parametric Darks",
	"ctrlParametricHighlights": "Parametric Highlights",
	"ctrlParametricLights": "Parametric Lights",
	"ctrlParametricShadows": "Parametric Shadows",
	"ctrlSaturation": "Saturation",
	"ctrlSaturationRange": "Saturation Range",
	"ctrlSaturationShift": "Saturation Shift",
	"ctrlSetColorProfile": "Set Color Profile",
	"ctrlShadows": "Shadows",
	"ctrlShadowsHue": "Shadows Hue",
	"ctrlShadowsLuminance": "Shadows Luminance",
	"ctrlShadowsSaturation": "Shadows Saturation",
	"ctrlSharpen": "Sharpen",
	"ctrlSharpness": "Sharpness",
	"ctrlStrength": "Strength",
	"ctrlTemperature": "Temperature",
	"ctrlTexture": "Texture",
	"ctrlTint": "Tint",
	"ctrlVibrance": "Vibrance",
	"ctrlVerticalPerspective": "Vertical Perspective",
	"ctrlVignette": "Vignette",
	"ctrlVignetteFeather": "Vignette Feather",
	"ctrlVignetteHighlights": "Vignette Highlights",
	"ctrlVignetteMidpoint": "Vignette Midpoint",
	"ctrlVignetteRoundness": "Vignette Roundness",
	"ctrlWBPicker": "White Balance Picker",
	"ctrlWhites": "Whites",
	"ctrlAddMask": "Add Mask",
	"ctrlUpdateMask": "Update Mask",
	"ctrlPurpleHue": "Purple Hue",
	"ctrlPurpleLuminance": "Purple Luminance",
	"ctrlPurpleSaturation": "Purple Saturation",
	"ctrlXOffset": "X Offset",
	"ctrlYOffset": "Y Offset",
	"ctrlYellowHue": "Yellow Hue",
	"ctrlYellowLuminance": "Yellow Luminance",
	"ctrlYellowSaturation": "Yellow Saturation",
	"healingResetRemovals": "Reset Removals",
	"manualAdjust": "Manual Adjust",
	"maskAdd": "Add {{maskType}} Mask",
	"maskHide": "Hide",
	"maskRemove": "Remove Mask",
	"maskShow": "Show",
	"noHistory": "No history available",
	"original": "Original",
	"pasteAdjustments": "Paste Adjustments",
	"ratingCleared": "Rating Cleared",
	"ratingUpdated": "Rating Updated",
	"resetAll": "Reset All",
	"selectPhotoPrompt": "Select a photo to view its edit history"
}
